var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9815 19.2248C16.6121 17.4175 14.4424 16.25 12 16.25C9.55761 16.25 7.38789 17.4175 6.01846 19.2248M17.9815 19.2248C19.8335 17.5763 21 15.1744 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 15.1744 4.1665 17.5763 6.01846 19.2248M17.9815 19.2248C16.3915 20.6401 14.2962 21.5 12 21.5C9.70383 21.5 7.60851 20.6401 6.01846 19.2248M15 10.25C15 11.9069 13.6569 13.25 12 13.25C10.3431 13.25 9 11.9069 9 10.25C9 8.59315 10.3431 7.25 12 7.25C13.6569 7.25 15 8.59315 15 10.25Z",
    stroke: "#F3D332",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user_circle.8e10159eb5a262789318877455724d84.svg";
export { ForwardRef as ReactComponent };